<template>
<div>
  <div class="success row-flex row-center-center row-column">
    <template v-if="orderInfo.paid || orderInfo.pay_type == 'offline'">
    <img src="../../assets/newImg/success.png" class="success" alt="">
    <div class="text-color" style="font-size:20px;font-weight:600;margin-top:-30px">支付成功</div>
    </template>
    <template v-else>
    <img src="../../assets/newImg/fail.png" class="success" alt="">
    <div class="text-color" style="font-size:20px;font-weight:600;margin-top:-30px">支付失败</div>
    </template>
  </div>
  <div style="height:20px"></div>
  <div class="suc-inter">
    <div class="li row-flex row-between-center">
      <div class="li-left">支付金额</div>
      <div class="li-right">{{dataSource.pay_price}}</div>
    </div>
    <div class="li row-flex row-between-center">
      <div class="li-left">剩余积分</div>
      <div class="li-right">{{dataSource.integral}}</div>
    </div>
  </div>
  <div style="height:10px"></div>
  <div class="suc-inter">
    <div class="li row-flex row-between-center">
      <div class="li-left">支付方式</div>
      <div class="li-right">{{dataSource.pay_type}}</div>
    </div>
  </div>
  <div style="height:10px"></div>
  <div class="income">
    <div class="title row-flex row-center-center">实时收入</div>
    <div class="month">
      <div class="month-title">本月当前收入：{{dataSource.income}}</div>
     <div class="table">
        <table border>
       <tr>
          <th>个人比例收入</th>
        <th>直属会员差额奖金</th>
        <th>推广奖金</th>
       </tr>
       <tr>
         <td>￥{{dataSource.amount}}</td>
         <td>￥{{dataSource.different_amount}}</td>
         <td>￥{{dataSource.tuiguang_amount}}</td>
       </tr>
      </table>
     </div>
    </div>
      <div class="progress">
    <div class="pro-top row-flex row-between-center">
      <div class="top-left">团队业绩 {{dataSource.team_text}}元</div>
      <div class="top-right">{{dataSource.max_money-dataSource.all_amount>=0 ?'未满足条件':'条件已满足'}}</div>
    </div>
    <div class="pre-center">
      <van-progress pivot-text="" :percentage="(dataSource.all_amount/dataSource.max_money>=1 ? 1:dataSource.all_amount/dataSource.max_money)*100" stroke-width="10px" color="#D01112" track-color="#F9E9EA" />
    </div>
    <div class="bottom row-flex row-between-center">
       <div class="top-left">还需要{{dataSource.max_money-dataSource.all_amount>=0 ?dataSource.max_money-dataSource.all_amount:0}}元</div>
      <div class="top-right"><span class="text-color">{{dataSource.all_amount}}</span>/{{dataSource.max_money}}</div>
    </div>
  </div>
  </div>
  <div class="back row-flex row-around-center">
    <div class="back-home text-color border-color"  @click="goPages('/')">返回首页</div>
    <div class="back-order bg-color" @click="goPages()">查看订单</div>
  </div>
  </div>
</template>
<style lang="scss" scoped>
.success{
  img{
   width: 134px; 
   height: 132px;
  }
}
.suc-inter{
  margin: 0 10px;
  background: #ffffff;
  border-radius: 5px;
box-shadow: 0px 1px 5px 0px rgba(157,157,157,0.20); 
  .li{
height: 40px;
padding: 0 11px;

div{
  font-size: 14px;
  color: #333333;
}
  }
}
.income{
height: 298px;
background: #ffffff;
border-radius: 5px;
box-shadow: 0px 1px 5px 0px rgba(157,157,157,0.20); 
margin: 0 10px;
.title{
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}
.month{
  .month-title{
    padding-left: 11px;
    font-size: 14px;
  }
}
.table{
  margin:11px ;
  table{
  // width: auto;
  border:1px solid #DEC1C1;
  tr{
    width: 100%;
          text-align: center;
      height: 36px;
      line-height: 36px;
    th{
      font-size: 14px;
      font-weight: 600;
    }
    td{
      color: #333;
      font-size: 12px;
    }
  }

}
}
}
.progress{
height: 120px;
background: #f8f8f8;
border-radius: 4px;
margin: 0 9px;
padding: 0 15px;
.pro-top{
  height: 60px;
  .top-left{
height: 20px;
line-height: 20px;
text-align: center;
color: #ffffff;
background: linear-gradient(270deg,#f9e9ea, #d01112 10%);
border-radius: 2px;
padding: 0 6px;
width: fit-content;
font-size: 10px;
font-weight: 600;
  }
  .top-right{
    font-size: 13px;
    color: #333333;
  }
}

.bottom{
height: 50px;
font-size: 16px;
}
}
.back{
  margin: 22px auto;
  div{
width: 160px;
height: 50px;
border-radius: 100px;
display: flex;
align-items: center;
justify-content: center;
font-size: 16px;
font-weight: 600;
  }
  .back-order{
    color: #ffffff;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import { orderDetail } from "@api/order";
import { isWeixin } from "@utils";
import Vue from 'vue';
import { Progress } from 'vant';
import {vipSpeed} from '@api/user';
Vue.use(Progress);
const NAME = "PayMentStatus";

export default {
  name: NAME,
  props: {},
  data: function() {
    return {
      id: "",
      status: 0,
      msgContent: "",
      orderInfo: {},
      isWeixin: isWeixin(),
      dataSource:{}
    };
  },
  watch: {
    $route(n) {
      if (n.query.msg) this.msgContent = n.query.msg;
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.status = parseInt(n.params.status);
        this.getOrderInfo();
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.id = this.$route.params.id;
    this.msgContent = this.$route.query.msg;
    this.status = parseInt(this.$route.params.status);
    this.getOrderInfo();
    this.vip();
  },
  methods: {
    goPages(route) {
      let routes =
        route !== undefined
          ? route
          : "/order/detail/" + this.orderInfo.order_id;
      if (this.status === 5 && route === undefined) routes = "/order/list/0";
      return this.$router.push({
        path: routes
      });
    },
    getOrderInfo() {
      orderDetail(this.id).then(res => {
        this.orderInfo = res.data;
        if (this.isWeixin) {
          document.title = this.orderInfo.paid ? "支付成功" : "支付失败";
        } else {
          document.title = "订单创建成功";
        }
      });
    },
    vip(){
      let params={}
      vipSpeed(params).then(res=>{
        this.dataSource=res.data.data;
      })
    },
  }
};
</script>
